// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-G":"G_cost-saving-G__0TGL8"};